import React, { useState } from "react";

import { Skeleton, SkeletonProps } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { Trash } from "iconsax-react";

import useStyles, { Figcaption } from "./styles";

type Props = {
  disabled?: boolean;
  src?: string;
  className?: string;
  skeleton?: SkeletonProps;
  onRemove?: () => void;
  onImageClick?: () => void;
};

const Picture = (props: Props) => {
  const { disabled, src, className, skeleton, onRemove, onImageClick } = props;

  const classes = useStyles();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const renderRemoveIcon = () => {
    if (onRemove && !disabled)
      return (
        <Figcaption disabled={disabled}>
          <Trash size="16" color={colors.white} onClick={disabled ? () => {} : () => onRemove()} />
        </Figcaption>
      );
  };

  const renderImage = () => {
    if (isLoading)
      return (
        <Skeleton
          variant="rectangular"
          className={classes.skeleton}
          width={240}
          height={300}
          {...(skeleton || {})}
        />
      );

    if (src) {
      return (
        <div className={isLoading ? classes.hide : undefined}>
          <figure className={classes.figure}>
            <img
              src={src}
              onLoad={() => setIsLoading(false)}
              className={className}
              onClick={() => onImageClick && onImageClick()}
            />
            {renderRemoveIcon()}
          </figure>
        </div>
      );
    }

    return <></>;
  };

  return renderImage();
};

export default Picture;
